/**
 * Tailwind's `theme.screens`, as a constant. This used to be `resolveConfig(tailwindConfig)` at
 * runtime, but this helper is used from client components (the heroes, ImageMedia), which pulled
 * Tailwind itself, postcss-selector-parser and the typography plugin — about 136 KB of
 * JavaScript — into the browser bundle just to read five breakpoints.
 *
 * tests/unit/tailwindScreens.spec.ts fails when tailwind.config.mjs stops matching these.
 */
export const TAILWIND_SCREENS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const

export default function getTailwindScreens() {
  return TAILWIND_SCREENS
}
